import { BlurViewProps, BlurView as _BlurView } from "expo-blur";

export const BlurView = (props: BlurViewProps) => {
  return <_BlurView blurReductionFactor={2} {...props} />;
};
